import '.g{display:grid;}.ssr-plugin'
import AgataImage from '@app/assets/images/about-us/team/Agata.jpg'
import BelaImage from '@app/assets/images/about-us/team/Bela.jpg'
import BrianImage from '@app/assets/images/about-us/team/Brian.jpg'
import EugeneImage from '@app/assets/images/about-us/team/Eugene.jpg'
import FreddieImage from '@app/assets/images/about-us/team/Freddie.jpg'
import GeorgieImage from '@app/assets/images/about-us/team/Georgie.jpg'
import GuusImage from '@app/assets/images/about-us/team/Guus.jpg'
import LauraImage from '@app/assets/images/about-us/team/Laura.jpg'
import LaurenImage from '@app/assets/images/about-us/team/Lauren.jpg'
import LisanneImage from '@app/assets/images/about-us/team/Lisanne.jpg'
import MichielImage from '@app/assets/images/about-us/team/Michiel.jpg'
import SaschaImage from '@app/assets/images/about-us/team/Sascha.jpg'
import TjeerdImage from '@app/assets/images/about-us/team/Tjeerd.jpg'
import VladImage from '@app/assets/images/about-us/team/Vlad.jpg'
import { TeamMember, TeamCard } from '@app/components/blocks/card/TeamCard'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'

const teamMembers: TeamMember[] = [
  {
    name: 'Agata Ageieva',
    role: 'Product',
    image: AgataImage,
    linkedIn: 'https://www.linkedin.com/in/agata-ageieva/',
  },
  {
    name: 'Bela Teiwes',
    role: 'Community',
    image: BelaImage,
    linkedIn: 'https://www.linkedin.com/in/b%C3%A9la-teiwes-765287336/',
  },
  {
    name: 'Brian Garret',
    role: 'Co-founder',
    image: BrianImage,
    linkedIn: 'https://www.linkedin.com/in/briangarret',
  },
  {
    name: 'Eugene de Beer',
    role: 'Product',
    image: EugeneImage,
    linkedIn: 'https://www.linkedin.com/in/eugene-de-beer/',
  },
  {
    name: 'Freddie Aldershoff',
    role: 'Partnerships',
    image: FreddieImage,
    linkedIn: 'https://www.linkedin.com/in/freddiealdershoff/',
  },
  {
    name: 'Georgie King',
    role: 'People',
    image: GeorgieImage,
    linkedIn: 'https://www.linkedin.com/in/georgiecking/',
  },
  {
    name: 'Guus Speelberg',
    role: 'Community',
    image: GuusImage,
    linkedIn: 'https://www.linkedin.com/in/guus-speelberg-2675592a0/',
  },
  {
    name: 'Laura Fransen',
    role: 'Partnerships',
    image: LauraImage,
    linkedIn: 'https://www.linkedin.com/in/laurafransen/',
  },
  {
    name: 'Lauren Dennehy',
    role: 'People',
    image: LaurenImage,
    linkedIn: 'https://www.linkedin.com/in/lauren-dennehy/',
  },
  {
    name: 'Lisanne Barnaart',
    role: 'Product',
    image: LisanneImage,
    linkedIn: 'https://www.linkedin.com/in/lisannebarnaart/',
  },
  {
    name: 'Michiel Voskamp',
    role: 'Partnerships',
    image: MichielImage,
    linkedIn: 'https://www.linkedin.com/in/michiel-voskamp-abc/',
  },
  {
    name: 'Sascha Glasl',
    role: 'Co-founder',
    image: SaschaImage,
    linkedIn: 'https://www.linkedin.com/in/saschaglasl/',
  },
  {
    name: 'Tjeerd Haccou',
    role: 'Co-founder',
    image: TjeerdImage,
    linkedIn: 'https://www.linkedin.com/in/tjeerd-haccou/',
  },
  {
    name: 'Vlad Musidze',
    role: 'Product',
    image: VladImage,
    linkedIn: 'https://www.linkedin.com/in/vladislav-musidze/',
  },
]

export const OurTeam = () => {
  const isMobile = useMediaQuery()

  return (
    <div className="g"
      style={{
        gap: isMobile ? '0.5rem' : '1.5rem',
        gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
      }}
    >
      {teamMembers.map((member, index) => (
        <TeamCard key={index} {...member} />
      ))}
    </div>
  )
}
